import { render, staticRenderFns } from "./LayoutAccordion.vue?vue&type=template&id=28e21b76&"
import script from "./LayoutAccordion.vue?vue&type=script&lang=js&"
export * from "./LayoutAccordion.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LayoutAccordion.vue"
export default component.exports